var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.044,
    height: 38.865,
    viewBox: "0 0 39.044 38.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loading",
    transform: "translate(0 -0.309)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 4.042,
    cy: 4.042,
    r: 4.042,
    transform: "translate(3.643 25.715)",
    fill: "#909ba6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 3.753,
    cy: 3.753,
    r: 3.753,
    transform: "translate(30.781 22.828)",
    fill: "#c8d2dc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 2.887,
    cy: 2.887,
    r: 2.887,
    transform: "translate(28.472 6.083)",
    fill: "#e9edf1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 4.419,
    cy: 4.311,
    rx: 4.419,
    ry: 4.311,
    transform: "translate(0 15.048)",
    fill: "#7e8b96"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 4.017,
    cy: 3.914,
    rx: 4.017,
    ry: 3.914,
    transform: "translate(13.095 31.346)",
    fill: "#a2abb8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 3.816,
    cy: 3.716,
    rx: 3.816,
    ry: 3.716,
    transform: "translate(23.619 30.028)",
    fill: "#b9c3cd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 4.619,
    cy: 4.509,
    rx: 4.619,
    ry: 4.509,
    transform: "translate(4.579 4.64)",
    fill: "#5f6c75"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 3.414,
    cy: 3.351,
    rx: 3.414,
    ry: 3.351,
    transform: "translate(32.215 13.786)",
    fill: "#dce6eb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 4.908,
    cy: 4.908,
    r: 4.908,
    transform: "translate(15.769 0.309)",
    fill: "#4e5a61"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.08bf1832.svg";
export { ForwardRef as ReactComponent };